import apps from "@services/applications";

export default [
  {
    path: "/app/editor",
    name: "content-editor",
    meta: {
      module: "content-editor",
      application: apps.Modules.ContentEditor.Id,
      title: "Content Editor"
    },
    component: () => import("@ContentEditor/views/ContentEditor.vue"),
    children: [
      {
        path: "article/:id",
        name: "article-editor",
        component: () => import("@ContentEditor/views/ArticleEditor.vue"),
        meta: {
          application: apps.Modules.ContentEditor.Id,
          authenticatedRoute: true
        }
      },
      {
        path: "variationGroup/:id",
        name: "variationGroup-editor",
        component: () => import("@ContentEditor/views/VariationGroupEditor.vue"),
        meta: {
          application: apps.Modules.ContentEditor.Id,
          authenticatedRoute: true
        }
      },
      {
        path: "catalogNode/:id",
        name: "catalogNode-editor",
        component: () => import("@ContentEditor/views/CatalogNodeEditor.vue"),
        meta: {
          application: apps.Modules.ContentEditor.Id,
          authenticatedRoute: true
        }
      },
      {
        path: "catalogHome",
        name: "catalog-home",
        component: () => import("@common/views/CatalogHome.vue")
      }
    ]
  }
];
